
export class Poker2RegistrationData {
    public userName: string;
    public email: string;
    public password: string;
}
